module.exports = __webpack_public_path__ + "static/media/53pic.3d5dc7c1.jpg";